/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Call,
  CreateCall201Response,
  CreateCallDto,
  UpdateCallComment200Response,
  UpdateCallDto,
} from '../models/index';
import {
    CallFromJSON,
    CallToJSON,
    CreateCall201ResponseFromJSON,
    CreateCall201ResponseToJSON,
    CreateCallDtoFromJSON,
    CreateCallDtoToJSON,
    UpdateCallComment200ResponseFromJSON,
    UpdateCallComment200ResponseToJSON,
    UpdateCallDtoFromJSON,
    UpdateCallDtoToJSON,
} from '../models/index';

export interface CreateCallRequest {
    createCallDto: CreateCallDto;
}

export interface GetCallsByPartnerIdRequest {
    partnerId: number;
}

export interface UpdateCallCommentRequest {
    id: number;
    updateCallDto: UpdateCallDto;
}

/**
 * 
 */
export class CallApi extends runtime.BaseAPI {

    /**
     * Create a new call
     */
    async createCallRaw(requestParameters: CreateCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCall201Response>> {
        if (requestParameters['createCallDto'] == null) {
            throw new runtime.RequiredError(
                'createCallDto',
                'Required parameter "createCallDto" was null or undefined when calling createCall().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/call`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCallDtoToJSON(requestParameters['createCallDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCall201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new call
     */
    async createCall(requestParameters: CreateCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCall201Response> {
        const response = await this.createCallRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get calls by partner id
     */
    async getCallsByPartnerIdRaw(requestParameters: GetCallsByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Call>>> {
        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling getCallsByPartnerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/call/partner/{partnerId}`;
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CallFromJSON));
    }

    /**
     * Get calls by partner id
     */
    async getCallsByPartnerId(requestParameters: GetCallsByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Call>> {
        const response = await this.getCallsByPartnerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a call comment
     */
    async updateCallCommentRaw(requestParameters: UpdateCallCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCallComment().'
            );
        }

        if (requestParameters['updateCallDto'] == null) {
            throw new runtime.RequiredError(
                'updateCallDto',
                'Required parameter "updateCallDto" was null or undefined when calling updateCallComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/call/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCallDtoToJSON(requestParameters['updateCallDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a call comment
     */
    async updateCallComment(requestParameters: UpdateCallCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.updateCallCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
